import React from 'react'
import { GridApi } from 'ag-grid-community'
import { noop } from 'lodash-es'
import { TextFlagButtonsContainer, getTextFlagButtonState, ToolbarTextFlagButton } from 'view/components/buttons'
import { CollectionColumnId, ContainerCollectionColumnId } from '../ColumnNames'
import { Locale, Translation } from 'locale'

export enum StagingGroupByOptions {
  UNGROUPED = 'UNGROUPED',
  COLLECTIONS = 'COLLECTIONS',
  CUSTOM = 'CUSTOM'
}

export interface StagingGroupByTogglesProps {
  gridApi: GridApi | null
}

export const StagingGroupByToggles: React.FunctionComponent<StagingGroupByTogglesProps> = props => {
  const { gridApi } = props

  let groupByValue = StagingGroupByOptions.CUSTOM
  const rowGroupColumns = gridApi?.getRowGroupColumns()
  if (rowGroupColumns?.length === 0) {
    groupByValue = StagingGroupByOptions.UNGROUPED
  } else if (
    rowGroupColumns?.length === 2 &&
    (rowGroupColumns[0].getColId() === ContainerCollectionColumnId.CONTAINER_COLLECTION_NAME ||
      rowGroupColumns[1].getColId() === CollectionColumnId.COLLECTION_NAME)
  ) {
    groupByValue = StagingGroupByOptions.COLLECTIONS
  }

  const handleUpdateGroupByValue = (option: StagingGroupByOptions) => {
    if (!gridApi) {
      return
    }
    if (option === StagingGroupByOptions.UNGROUPED) {
      gridApi.setRowGroupColumns([])
    } else if (option === groupByValue) {
      gridApi.setRowGroupColumns([])
    } else if (option === StagingGroupByOptions.COLLECTIONS) {
      gridApi.setRowGroupColumns([ContainerCollectionColumnId.CONTAINER_COLLECTION_NAME, CollectionColumnId.COLLECTION_NAME])
    } else {
      throw new Error(`Unhandled StagingGroupByOption ${[option]}`)
    }
    gridApi.applyColumnState({ defaultState: { sort: null } })
  }

  return (
    <TextFlagButtonsContainer>
      <ToolbarTextFlagButton
        dataTestId={'StagingGroupByToggles-ToolbarTextFlagButton-Ungrouped'}
        state={getTextFlagButtonState(groupByValue === StagingGroupByOptions.UNGROUPED)}
        onClick={() => handleUpdateGroupByValue(StagingGroupByOptions.UNGROUPED)}>
        {Locale.translate(Translation.TC_GROUPING_UNGROUPED)}
      </ToolbarTextFlagButton>
      <ToolbarTextFlagButton
        dataTestId={'StagingGroupByToggles-ToolbarTextFlagButton-GroupingCollections'}
        state={getTextFlagButtonState(groupByValue === StagingGroupByOptions.COLLECTIONS)}
        onClick={() => handleUpdateGroupByValue(StagingGroupByOptions.COLLECTIONS)}>
        {Locale.translate(Translation.TC_GROUPING_COLLECTIONS)}
      </ToolbarTextFlagButton>
      {groupByValue === StagingGroupByOptions.CUSTOM && (
        <ToolbarTextFlagButton
          dataTestId={'StagingGroupByToggles-ToolbarTextFlagButton-Custom'}
          state={getTextFlagButtonState(groupByValue === StagingGroupByOptions.CUSTOM)}
          disabled={true}
          onClick={noop}>
          {Locale.translate(Translation.TC_GROUPING_CUSTOM)}
        </ToolbarTextFlagButton>
      )}
    </TextFlagButtonsContainer>
  )
}
